import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LayzImage } from "components";

import { SampleProduct, ShineLogoBw } from "assets/images";
import { Add, Minus, Trash } from "iconsax-react";

import styles from "./styles.module.css";
import useColors from "utils/Colors";

import useCart from "hooks/useCart";
import ReactLoading from "react-loading";
import { useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { toJalaali } from "jalaali-js";

const ProductCard = ({
  id,
  product,
  price,
  inventory,
  vendor,
  is_out_of_stock,
  cart_quantity,
  sale_price,
  is_on_sale,
  ...props
}) => {
  const channelId = useSelector(({ common }) => common.channelId);
  const user = useSelector(({ auth }) => auth.user);

  const queryClient = useQueryClient();

  const [quantity, setQuantity] = useState(0);
  const [boxQuantity, setBoxQuantity] = useState(0);
  const [maxPurchase, setMaxPurchase] = useState(Infinity);
  const [loading, setLoading] = useState(false);
  const [boxLoading, setBoxLoading] = useState(false);
  const [b2bBoxExpanded, setB2bBoxExpanded] = useState(false);

  const { CartItemAction } = useCart();
  const Colors = useColors();

  const _cartItemAction = async (action, shiring, manaualQuantity) => {
    if (user?.can_submit_b2b_order || channelId == "B2C") {
      if (!manaualQuantity) {
        shiring ? setBoxLoading(true) : setLoading(true);
      }
      const quantityToSend = manaualQuantity
        ? manaualQuantity
        : action == "increase"
          ? quantity + 1
          : quantity - 1;
      try {
        const res = await CartItemAction({
          action,
          vendor_product: id,
          quantity: shiring ? (product.box_quantity ?? 1) : quantityToSend,
        });
        if (channelId == "B2B") {
          const newQuntity =
            action == "increase"
              ? shiring
                ? _getFullQuantity() + (product.box_quantity ?? 1)
                : _getFullQuantity() + 1
              : shiring
                ? _getFullQuantity() - (product.box_quantity ?? 1)
                : _getFullQuantity() - 1;

          if (newQuntity == 0) {
            setB2bBoxExpanded(false);
          }
          const boxes = parseInt(newQuntity / product.box_quantity ?? 1);
          setBoxQuantity(boxes);
          setQuantity(newQuntity % product.box_quantity ?? 1);
          if (manaualQuantity) {
            toast.success("تغییرات سبد خرید اعمال شد");
          }
        } else {
          setQuantity(quantityToSend);
        }
        queryClient.invalidateQueries({ queryKey: ["[List] carts"] });
        shiring ? setBoxLoading(false) : setLoading(false);
      } catch (error) {
        shiring ? setBoxLoading(false) : setLoading(false);
      }
    } else {
      try {
        toast.info(`
          شما امروز امکان ثبت سفارش ندارید
                    ${" "}                                                                                                                                                  
          تاریخ سفارش بعدی شما: ${
            toJalaali(new Date(user?.next_visit_tour_day)).jy
          }/${toJalaali(new Date(user?.next_visit_tour_day)).jm}/${
            toJalaali(new Date(user?.next_visit_tour_day)).jd
          }
          `);
      } catch (error) {
        toast.error("خطا در بروزرسانی سبد خرید");
      }
    }
  };

  const _getFullQuantity = () => {
    return quantity + boxQuantity * product.box_quantity ?? 1;
  };

  const _renderquantityAction = () => {
    if (channelId == "B2B" && !b2bBoxExpanded) {
      return (
        <Add
          color={Colors.Primary["3"]}
          size={18}
          onClick={() => setB2bBoxExpanded(true)}
        />
      );
    } else if (
      quantity == 0 &&
      _getFullQuantity() < maxPurchase &&
      channelId != "B2B"
    ) {
      return !loading ? (
        <Add
          color={Colors.Primary["3"]}
          size={18}
          onClick={() => _cartItemAction("increase")}
        />
      ) : (
        <ReactLoading
          type={"spin"}
          color={Colors.Primary["3"]}
          width={20}
          height={20}
        />
      );
    } else if (
      (quantity == 1 && _getFullQuantity() < maxPurchase) ||
      channelId == "B2B"
    ) {
      return [
        <Add
          color={Colors.Primary["3"]}
          size={18}
          onClick={() => _cartItemAction("increase")}
        />,
        loading ? (
          <ReactLoading
            type={"spin"}
            color={Colors.Primary["3"]}
            width={20}
            height={20}
            className={styles.spinner}
          />
        ) : (
          <input
            type="number"
            placeholder="تعداد"
            defaultValue={quantity}
            className={styles.q_inp}
            name="quan-inp"
            onChange={(e) => {
              e.target.value != "" &&
                _cartItemAction("change", undefined, parseInt(e.target.value));
            }}
          />
        ),
        <Trash
          color={Colors.Primary["3"]}
          size={18}
          onClick={() => _cartItemAction("decrease")}
        />,
      ];
    } else if (quantity > 0 && _getFullQuantity() < maxPurchase) {
      return [
        <Add
          color={Colors.Primary["3"]}
          size={18}
          onClick={() => _cartItemAction("increase")}
        />,
        loading ? (
          <ReactLoading
            type={"spin"}
            color={Colors.Primary["3"]}
            width={20}
            height={20}
            className={styles.spinner}
          />
        ) : (
          <input
            type="number"
            placeholder="تعداد"
            defaultValue={quantity}
            className={styles.q_inp}
            ame="quan-inp"
            onChange={(e) => {
              e.target.value != "" &&
                _cartItemAction("change", undefined, parseInt(e.target.value));
            }}
          />
        ),
        <Minus
          color={Colors.Primary["3"]}
          size={18}
          onClick={() => _cartItemAction("decrease")}
        />,
      ];
    } else if (_getFullQuantity() == maxPurchase) {
      return [
        <Add color={Colors.Primary["3"]} size={18} onClick={() => {}} />,
        <div className="d-flex flex-column align-items-center">
          {loading ? (
            <ReactLoading
              type={"spin"}
              color={Colors.Primary["3"]}
              width={20}
              height={20}
              className={styles.spinner}
            />
          ) : (
            <input
              type="number"
              placeholder="تعداد"
              defaultValue={quantity}
              className={styles.q_inp}
              ame="quan-inp"
              onChange={(e) => {
                e.target.value != "" &&
                  _cartItemAction(
                    "change",
                    undefined,
                    parseInt(e.target.value),
                  );
              }}
            />
          )}
          <span className={styles.max_num}>حداکثر</span>
        </div>,
        <Minus
          color={Colors.Primary["3"]}
          size={18}
          onClick={() => _cartItemAction("decrease")}
        />,
      ];
    }
  };

  const _renderboxQuantityAction = () => {
    if (boxQuantity == 0) {
      return [
        <Add
          color={Colors.Primary["3"]}
          size={18}
          onClick={() => _cartItemAction("increase", true)}
        />,
        boxLoading ? (
          <ReactLoading
            type={"spin"}
            color={Colors.Primary["3"]}
            width={20}
            height={20}
            className={styles.spinner}
          />
        ) : (
          <span>{boxQuantity}</span>
        ),
        <div style={{ width: 18 }}></div>,
      ];
    } else if (
      boxQuantity == 1 &&
      _getFullQuantity() + product.box_quantity <= maxPurchase
    ) {
      return [
        <Add
          color={Colors.Primary["3"]}
          size={18}
          onClick={() => _cartItemAction("increase", true)}
        />,
        boxLoading ? (
          <ReactLoading
            type={"spin"}
            color={Colors.Primary["3"]}
            width={20}
            height={20}
            className={styles.spinner}
          />
        ) : (
          <span>{boxQuantity}</span>
        ),
        <Trash
          color={Colors.Primary["3"]}
          size={18}
          onClick={() => _cartItemAction("decrease", true)}
        />,
      ];
    } else if (
      boxQuantity > 0 &&
      _getFullQuantity() + product.box_quantity <= maxPurchase
    ) {
      return [
        <Add
          color={Colors.Primary["3"]}
          size={18}
          onClick={() => _cartItemAction("increase", true)}
        />,
        boxLoading ? (
          <ReactLoading
            type={"spin"}
            color={Colors.Primary["3"]}
            width={20}
            height={20}
            className={styles.spinner}
          />
        ) : (
          <span>{boxQuantity}</span>
        ),
        <Minus
          color={Colors.Primary["3"]}
          size={18}
          onClick={() => _cartItemAction("decrease", true)}
        />,
      ];
    } else if (_getFullQuantity() <= maxPurchase) {
      return [
        <Add color={Colors.Primary["3"]} size={18} onClick={() => {}} />,
        <div className="d-flex flex-column align-items-center">
          {boxLoading ? (
            <ReactLoading
              type={"spin"}
              color={Colors.Primary["3"]}
              width={20}
              height={20}
              className={styles.spinner}
            />
          ) : (
            <span>{boxQuantity}</span>
          )}
          <span className={styles.max_num}>حداکثر</span>
        </div>,
        <Minus
          color={Colors.Primary["3"]}
          size={18}
          onClick={() => _cartItemAction("decrease", true)}
        />,
      ];
    }
  };

  useEffect(() => {
    product.max_purchase && setMaxPurchase(product.max_purchase);
  }, [id]);

  useEffect(() => {
    if (channelId == "B2B") {
      const boxes = parseInt(cart_quantity / product.box_quantity ?? 1);
      setBoxQuantity(boxes);
      setQuantity(cart_quantity % product.box_quantity ?? 1);
      if (cart_quantity > 0) {
        setB2bBoxExpanded(true);
      }
    } else {
      setQuantity(cart_quantity);
    }
  }, [cart_quantity]);

  return (
    <Link
      style={{ width: "100%" }}
      to={is_out_of_stock ? "#" : `/products/single/${id}`}
    >
      <div className={styles.container}>
        {vendor && channelId == "B2C" && (
          <div className={styles.vendor_header}>{vendor.name}</div>
        )}
        <div className={`${styles.header} ${vendor ? styles.has_vendor : ""}`}>
          <LayzImage
            className={`${is_out_of_stock && styles.gray_img}`}
            src={
              product.featured_image
                ? `${product.featured_image.file}?date=${new Date().toISOString()}`
                : ShineLogoBw
            }
          />
          {!is_out_of_stock &&
            (channelId == "B2B" ? (
              <span
                onClick={(e) => e.preventDefault()}
                href="#"
                className={`${styles.header_action} ${
                  b2bBoxExpanded ? "is-expanded" : ""
                } ${loading ? "loading" : ""}`}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  {(b2bBoxExpanded || _getFullQuantity() > 0) && (
                    <div
                      className={styles.b2b_row_action}
                      style={{ marginBottom: 4 }}
                    >
                      <p>بسته:</p>
                      <div className={styles.b2b_row_action_inner}>
                        {_renderboxQuantityAction()}
                      </div>
                    </div>
                  )}
                  <div className={styles.b2b_row_action}>
                    {(b2bBoxExpanded || _getFullQuantity() > 0) && (
                      <p>تعداد:</p>
                    )}
                    <div className={styles.b2b_row_action_inner}>
                      {_renderquantityAction()}
                    </div>
                  </div>
                </div>
              </span>
            ) : (
              <span
                onClick={(e) => e.preventDefault()}
                href="#"
                className={`${styles.header_action} ${
                  quantity > 0 ? "is-expanded" : ""
                } ${loading ? "loading" : ""}`}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  {_renderquantityAction()}
                </div>
              </span>
            ))}
        </div>
        <div className={styles.body}>
          <h5>{product.name}</h5>
          <span
            style={{
              color: Colors.Grey["3"],
              fontSize: 12,
              marginBottom: 12,
              display: "flex",
            }}
          >
            کد محصول: {product?.internal_code}
          </span>
          <span className={styles.weight_txt}>{product.amount_unit}</span>
          <div className="w-100 d-flex justify-content-start align-items-center flex-wrap">
            {is_out_of_stock ? (
              <span className={styles.insufficient_label}>ناموجود</span>
            ) : is_on_sale ? (
              <>
                <span className={styles.initial_price}>
                  <strong>{sale_price?.toLocaleString()}</strong> تومان
                </span>{" "}
                <span className={styles.discount_price}>
                  <strong>{price?.toLocaleString()}</strong> تومان
                </span>
                <span className={styles.discount_label}>
                  {parseInt(((price - sale_price) / price) * 100)}%
                </span>
              </>
            ) : (
              <span className={styles.initial_price}>
                <strong>{price?.toLocaleString()}</strong> تومان
              </span>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

ProductCard.defaultProps = {
  id: 1,
  slug: "khame",
  brand: null,
  category: {
    id: 2,
    name: "خامه",
  },
  product: {
    name: "خامه شکلاتی نیم چرب پگاه",
    max_purchase: 1,
    featured_image: {
      id: 1,
      size: 125734,
      type: ".png",
      image_dimensions: {
        height: 312,
        width: 427,
      },
      file: "http://shine-api.codarx.com/media/uploads/2023/02/19/Group_21830.png",
      name: "test",
      alt: "test",
      created_date: "2023/02/19 14:28",
      modified_date: "2023/02/19 14:53",
    },
  },
  price: 3000,
  is_available: true,
  channel: 2,
  cart_quantity: 0,
};

export default ProductCard;
